//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    isHasInfo: {
      type: Boolean,
      default: false
    },
    currentType: {
      type: String,
      default: 'list'
    }
  },
  data: function data() {
    return {
      isShowSeach: true,
      // 查询
      isShowEditOrder: false,
      // 修改
      isShowAdd: true,
      // 新增
      isShowBlack: false,
      // 返回
      isShowSave: false,
      // 保存
      isShowCancel: false,
      // 取消
      isShowEmailTest: false // 邮件测试

    };
  },
  mounted: function mounted() {},
  methods: {
    // 点击邮件测试
    handelEmailTest: function handelEmailTest() {
      this.$emit('handelEmailTest');
    },
    // 控制按钮显示
    controlBtnShow: function controlBtnShow(status) {
      // console.log('控制按钮显示 status=====',status);
      if (status === 1) {// 未确认
      } else if (status === 2) {// 已审核
      } else if (status === 3) {// 作废
      }
    },
    // 点击保存单据
    handleSaveOrder: function handleSaveOrder() {
      this.$emit('handleSaveOrder');
    },
    // 点击取消
    handleCancelBtn: function handleCancelBtn() {
      this.$emit('handleCancelBtn');
    },
    // 点击修改
    handleEditOrder: function handleEditOrder() {},
    // 点击新增
    handelAddBtn: function handelAddBtn() {
      this.$emit('handelAddBtn');
    }
  },
  watch: {
    isHasInfo: {
      handler: function handler(val) {
        if (val === true) {
          this.isShowEditOrder = true;
          this.isShowAdd = false;
          this.isShowEmailTest = true;
        } else {
          this.isShowEditOrder = false;
          this.isShowAdd = true;
          this.isShowEmailTest = false;
        }
      },
      immediate: true
    },
    currentType: function currentType(val) {
      // 当前状态
      if (val === 'list') {
        this.isHasInfo === true ? this.isShowEditOrder = true : this.isShowAdd = true;
        this.isShowEmailTest = true;
        this.isShowCancel = false;
        this.isShowSave = false;
      } else if (val === 'edit') {
        this.isHasInfo === true ? this.isShowEditOrder = false : this.isShowAdd = false;
        this.isShowSave = true;
        this.isShowCancel = true;
        this.isShowEmailTest = false;
        this.isShowSave = true;
      }
    }
  }
};